import { useEffect, useState } from "react";
import { Carregando } from "../../components/Layout";
import { api } from "../../lib/api";

type DashboardDto = {
  edital: { anoLetivo: number };
  totalInscricoes: number;
  porStatus: Record<string, number>;
  porCargo: Record<string, number>;
  porModalidade: Record<string, number>;
  faseAtual: string;
  recursosPendentes: number;
};

const ROTULO_STATUS: Record<string, string> = {
  RECEBIDA: "Recebidas", EM_ANALISE: "Em análise", DEFERIDA: "Deferidas",
  INDEFERIDA: "Indeferidas", CLASSIFICADA: "Classificadas", CONVOCADA: "Convocadas",
  CONTRATADA: "Contratadas", ELIMINADA: "Eliminadas", RASCUNHO: "Rascunhos",
};

export function Dashboard() {
  const [dados, setDados] = useState<DashboardDto | null>(null);

  useEffect(() => { api.get<DashboardDto>("/api/admin/dashboard").then(setDados).catch(() => setDados(null)); }, []);

  if (!dados) return <Carregando texto="Carregando o painel" />;

  const aguardando = (dados.porStatus.RECEBIDA ?? 0) + (dados.porStatus.EM_ANALISE ?? 0);

  return (
    <div className="pilha pilha-8">
      <div>
        <h1>Visão geral</h1>
        <p className="texto-secundario">
          Ano letivo {dados.edital.anoLetivo} · fase atual: <strong>{dados.faseAtual}</strong>
        </p>
      </div>

      <dl className="resumo-cartoes">
        <div className="cartao resumo-cartao">
          <dt>Inscrições enviadas</dt>
          <dd className="num">{dados.totalInscricoes}</dd>
        </div>
        <div className="cartao resumo-cartao">
          <dt>Aguardando análise</dt>
          <dd className="num">{aguardando}</dd>
        </div>
        <div className="cartao resumo-cartao">
          <dt>Deferidas</dt>
          <dd className="num">{dados.porStatus.DEFERIDA ?? 0}</dd>
        </div>
        <div className="cartao resumo-cartao">
          <dt>Recursos pendentes</dt>
          <dd className="num">{dados.recursosPendentes}</dd>
        </div>
      </dl>

      <div className="relatorio-grade">
        <div>
          <section className="bloco-relatorio">
            <h2>Situação das inscrições</h2>
            <div className="barras">
              {Object.entries(dados.porStatus)
                .filter(([s]) => s !== "RASCUNHO")
                .sort((a, b) => b[1] - a[1])
                .map(([status, qtd]) => (
                  <div key={status} className="barra-linha">
                    <span className={`situacao situacao-${status}`} style={{ justifySelf: "start" }}>
                      {ROTULO_STATUS[status] ?? status}
                    </span>
                    <div className="barra-trilho">
                      <div className="barra-preenchida"
                           style={{ width: `${(qtd / Math.max(dados.totalInscricoes, 1)) * 100}%` }} />
                    </div>
                    <span className="num">{qtd}</span>
                  </div>
                ))}
            </div>
          </section>

          <Distribuicao titulo="Por cargo" dados={dados.porCargo} total={dados.totalInscricoes} />

          <Distribuicao
            titulo="Por modalidade de concorrência"
            dados={dados.porModalidade}
            total={dados.totalInscricoes}
            rotulos={{ AMPLA: "Ampla concorrência", PCD: "Pessoa com Deficiência", NEGRO: "Vaga reservada a negros" }}
          />
        </div>

      </div>
    </div>
  );
}

function Distribuicao({ titulo, dados, total, rotulos }: {
  titulo: string; dados: Record<string, number>; total: number;
  rotulos?: Record<string, string>;
}) {
  const entradas = Object.entries(dados).sort((a, b) => b[1] - a[1]);
  return (
    <section className="bloco-relatorio">
      <h2>{titulo}</h2>
      <div className="barras">
        {entradas.length === 0 && <p className="texto-sutil">Sem dados.</p>}
        {entradas.map(([chave, qtd]) => (
          <div key={chave} className="barra-linha">
            <span>{rotulos?.[chave] ?? chave}</span>
            <div className="barra-trilho">
              <div className="barra-preenchida" style={{ width: `${(qtd / Math.max(total, 1)) * 100}%` }} />
            </div>
            <span className="num">{qtd}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
